import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const analyzeVideo = async ({ files, batterName, handedness, mode }, onProgress) => {
  const fd = new FormData();
  files.forEach((f) => fd.append("files", f.file));
  fd.append("camera_angles", files.map((f) => f.angle).join("||"));
  fd.append("batter_name", batterName);
  fd.append("handedness", handedness);
  fd.append("mode", mode);
  const res = await axios.post(`${API}/analyze-video`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 300000,
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
    },
  });
  return res.data;
};

export const analyzeSession = async ({ file, batterName, handedness }, onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("batter_name", batterName);
  fd.append("handedness", handedness);
  const res = await axios.post(`${API}/analyze-session`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 300000,
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
    },
  });
  return res.data;
};

export const listAssessments = async () => {
  const res = await axios.get(`${API}/assessments`);
  return res.data;
};

export const getAssessment = async (id) => {
  const res = await axios.get(`${API}/assessments/${id}`);
  return res.data;
};

export const deleteAssessment = async (id) => {
  const res = await axios.delete(`${API}/assessments/${id}`);
  return res.data;
};

export const mediaUrl = (id, idx = 0) => `${API}/media/${id}?idx=${idx}`;

export const scoreTier = (s) => {
  if (s >= 90) return { label: "ELITE", color: "#10B981", bg: "rgba(16,185,129,0.12)", border: "rgba(16,185,129,0.35)" };
  if (s >= 75) return { label: "PROFICIENT", color: "#06B6D4", bg: "rgba(6,182,212,0.12)", border: "rgba(6,182,212,0.35)" };
  if (s >= 60) return { label: "DEVELOPING", color: "#F59E0B", bg: "rgba(245,158,11,0.12)", border: "rgba(245,158,11,0.35)" };
  return { label: "NEEDS WORK", color: "#EF4444", bg: "rgba(239,68,68,0.12)", border: "rgba(239,68,68,0.35)" };
};

export const ratingColor = (r) => {
  const v = (r || "").toLowerCase();
  if (v === "good") return "#10B981";
  if (v === "fair") return "#F59E0B";
  return "#EF4444";
};
